import { render } from "./Table.vue?vue&type=template&id=843fbb68&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=843fbb68&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-843fbb68"

export default script